import { render, staticRenderFns } from "./ResourceItem.vue?vue&type=template&id=7c7f8c8f"
import script from "./ResourceItem.ts?vue&type=script&lang=ts&external"
export * from "./ResourceItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports